import api from '../../gql/api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { setEmergencyContacts } from '../slices/emergencyContacts';
import { setCurrentWorkspaceEmergencyContactIds } from '../slices/currentWorkspace';
import _ from 'lodash';

export const getEmergencyContactByWorkspaceId = createAsyncThunk(
  'monitoring/getEmergencyContactByWorkspaceId',
  async (payload, { dispatch }) => {
    const {
      workspaceId,
      setLoading = () => {},
      setErrors = () => {},
    } = payload;

    if (!_.isEmpty(workspaceId)) {
      setLoading(true);
      try {
        const response =
          await api.emergencyContact.getEmergencyContactByWorkspaceId({
            workspaceId,
          });

        if (response.data.getEmergencyContactByWorkspaceId?.emergencyContacts) {
          dispatch(
            setEmergencyContacts(
              response.data.getEmergencyContactByWorkspaceId.emergencyContacts
            )
          );

          dispatch(
            setCurrentWorkspaceEmergencyContactIds(
              response.data.getEmergencyContactByWorkspaceId.emergencyContacts.map(
                (resolution) => resolution.id
              )
            )
          );

          setLoading(false);
          return response.data.getEmergencyContactByWorkspaceId
            .emergencyContacts;
        }
      } catch (error) {
        setErrors(error.message);
        setLoading(false);
        return null;
      }
    } else {
      setErrors('generalError');
      setLoading(false);
      return null;
    }
    return null;
  }
);

export const createEmergencyContact = createAsyncThunk(
  'emergencyContact/createEmergencyContact',
  async (payload) => {
    const emergencyContactCreated =
      await api.emergencyContact.createEmergencyContact({
        data: payload,
      });

    return emergencyContactCreated.data.createEmergencyContact;
  }
);

export const deleteEmergencyContactById = createAsyncThunk(
  'emergencyContact/deleteEmergencyContactById',
  async (payload) => {
    const { id } = payload;
    const emergencyContactDeleted =
      await api.emergencyContact.deleteEmergencyContactById({ id });
    return emergencyContactDeleted.data.deleteEmergencyContactById;
  }
);

export const updateEmergencyContact = createAsyncThunk(
  'emergencyContact/EmergencyContactById',
  async (payload) => {
    const { id, data } = payload;
    const emergencyContactUpdated =
      await api.emergencyContact.updateEmergencyContact({
        id,
        data,
      });

    return emergencyContactUpdated.data.updateEmergencyContactById;
  }
);
